module.exports = {
          srcSet: __webpack_public_path__ + "ff7c94232513655217fb7246a0f06bba-30.png"+" 30w",
          images:[ {path: __webpack_public_path__ + "ff7c94232513655217fb7246a0f06bba-30.png",width: 30,height: 19}],
          src: __webpack_public_path__ + "ff7c94232513655217fb7246a0f06bba-30.png",
          toString:function(){return __webpack_public_path__ + "ff7c94232513655217fb7246a0f06bba-30.png"},
          
          width: 30,
          height: 19
        }